import { NgModule } from '@angular/core';

import { CommonUIModules } from '../../modules';
import { SortArrowComponent } from './sort-arrow.component';

@NgModule({
  imports: [CommonUIModules],
  declarations: [SortArrowComponent],
  exports: [SortArrowComponent],
})
export class SortArrowModule {}
